export default __webpack_public_path__ + "30333fdb888a7676e8f15870786d2c09.svg";